import React from "react";
import Link from "@herb/components/Link";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import categoryPath from "@herb/utils/categoryPath";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

/**
 * Posts are routed by gatsby-node as `/{categoryPath}/{slug}`, which nests a
 * child category into the path (`/news/legalization/...`). WordPress's own
 * `uri` only ever contains the primary category, so it points at a URL that
 * does not exist for any post filed under a child category. Build the path the
 * same way the routing does, and keep `uri` only as a fallback for posts that
 * arrive without categories.
 */
const postPath = post => {
  const categories = post.categories?.nodes;

  if (post.slug && categories && categories.length) {
    return `/${categoryPath(post.categories)}/${post.slug}/`;
  }

  return post.uri;
};

/**
 * "Keep Up With The Story" — the right column of the two-up story row.
 * Each related post is a single link target (thumbnail + title).
 */
const HempBanStories = ({ whatsHappening }) => {
  if (!whatsHappening) {
    return null;
  }

  const { badge2Text, heading2, articles = [] } = whatsHappening;
  const posts = (articles || [])
    .filter(Boolean)
    .map(article => ({ ...article, path: postPath(article) }))
    .filter(article => !!article.path);

  if (!posts.length) {
    return null;
  }

  return (
    <div className="hb-stories">
      <HempBanSectionHead badgeText={badge2Text} heading={heading2} />

      <ul className="hb-stories-list">
        {posts.map(post => {
          const image = post.featuredImage?.node;

          return (
            <li className="hb-story" key={post.id}>
              <Link className="hb-story-link" to={post.path}>
                <span className="hb-story-thumb">
                  {image?.sourceUrl ? (
                    <img
                      src={replaceImageCdn(image.sourceUrl)}
                      alt={image.altText || ""}
                      loading="lazy"
                    />
                  ) : null}
                </span>
                <span className="hb-story-title">{post.title}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HempBanStories;
